import { validatePresence, validateLength } from 'ember-changeset-validations/validators';

export default {
  name: validatePresence(true),
  permissions: [validatePresence(true), validateLength({ min: 1 })]
};
